import { Box, Container, Typography, TextField, InputAdornment, Link, Button } from "@mui/material"
import Layout from "./Layout"
import theme from "./Theme"
import SearchIcon from '@mui/icons-material/Search';
import { SupportArticle } from "./Support";
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useEffect } from "react";
import { useState } from "react";
import { router, usePage } from "@inertiajs/react";

export default function SupportCategory(props: {support_articles: SupportArticle[], category: string}) {
  const { support_articles, category } = props;
  const [search, setSearch] = useState('');
  const [filteredArticles, setFilteredArticles] = useState(support_articles);
  const [newArticleTitle, setNewArticleTitle] = useState('');
  const { user } = usePage().props;

  useEffect(() => {
    setFilteredArticles(support_articles.filter((article) => article.title.includes(search)));
  }, [search, support_articles]);

  const handleAddNewArticle = () => {
    router.post(
      '/support', { title: newArticleTitle, category: category },
      { onSuccess: () => setNewArticleTitle('') }
    );
  }

  return (
    <Layout title="Support">
      <Container>
        <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', p: 3, mt: 9, width: '100%'}}>
          <Typography sx={{ color: theme.pandia.indigo_dark, fontWeight: 790 }} variant="h2">Resources for {category}</Typography>
          <Typography sx={{ fontWeight: 400 }} variant="h5">All your how to's and support needs</Typography>
          <TextField 
            placeholder="Search support" 
            variant="outlined" 
            onChange={(e) => setSearch(e.target.value)}
            slotProps={{
              input: {
                startAdornment: <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              }
            }}
            sx={{ mt: 3, width: '100%', maxWidth: '762px' }}
          />
          <Box sx={{ display: 'flex', flexDirection: 'column', p: 3, mt: 4, gap: 3, width: '100%', border: '1px solid', borderColor: theme.palette.primary.main, borderRadius: '8px', maxWidth: '742px' }}>
            {user.role === 'pandia_admin' && (
              <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'center', gap: 2, width: '100%' }}>
                <TextField size="small" label="New article title" variant="outlined" onChange={(e) => setNewArticleTitle(e.target.value)} />
                <Button variant="contained" color="primary" sx={{ }} onClick={handleAddNewArticle}>Add new article</Button>
              </Box>
            )}
            {filteredArticles.map(({id, title}) => (
              <Link 
                href={`/support/${id}`} 
                key={id}
                style={{ flex: 1, display: 'flex', alignItems: 'center', 
                  justifyContent: 'space-between', textDecoration: 'none', color: 'black'
                }}
              >
                <Typography variant="body1" sx={{ fontSize: 18 }}>{title}</Typography>
                <ArrowForwardIcon />
              </Link>
            ))}
          </Box>
        </Box>
      </Container>
    </Layout>
  )
}